export default class BookletIndex {
    constructor() {
        this.bindEvents();
        this.initImageZoom();
    }

    bindEvents() {
        this.setupNotifyStudentLevelModal();
        this.commentCarousetBulletSpy();
        this.levelAlertCarousetBulletSpy();

        this.scrollSpy = new bootstrap.ScrollSpy(document.body, {
            target: '#booklet-tabs'
        });

        document.querySelectorAll('#booklet-tabs.nav li a').forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const element = document.querySelector(link.getAttribute('href'));
                const offset = window.innerWidth < 768 ? 180 : 120;
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: elementPosition - offset,
                    behavior: 'smooth'
                });
                document.querySelectorAll('#booklet-tabs.nav li a').forEach(a => a.classList.remove('active'));
                link.classList.add('active');
            });
        });
    }

    initImageZoom() {
        // Import the ImageZoom utility
        import('../utils/ImageZoom').then(module => {
            const ImageZoom = module.default;
            // Create an instance of the image zoom utility
            this.imageZoom = new ImageZoom();
        });
    }

    levelAlertCarousetBulletSpy() {
        var scrollContainer = document.querySelector('.horizontal-alert-scroll-container .overflow-auto');
        var bullets = document.querySelectorAll('.alert-level-bullet');
        
        if (scrollContainer && bullets.length) {
            bullets[0].classList.add('active');
            
            scrollContainer.addEventListener('scroll', function() {
                const scrollPosition = scrollContainer.scrollLeft;
                const firstItem = scrollContainer.querySelector('.alert-level-card');
                const itemWidth = firstItem ? firstItem.offsetWidth + 16 : 300 + 12; // width + margin, fallback to default
                const activeIndex = Math.round(scrollPosition / itemWidth);
                
                bullets.forEach((bullet, index) => {
                    bullet.classList.toggle('active', index === activeIndex);
                });
            });
        }
    }

    commentCarousetBulletSpy() {
        var scrollContainer = document.querySelector('.horizontal-scroll-container .overflow-auto');
        var bullets = document.querySelectorAll('.comment-bullet');
        
        if (scrollContainer && bullets.length) {
            bullets[0].classList.add('active');
            
            scrollContainer.addEventListener('scroll', function() {
                const scrollPosition = scrollContainer.scrollLeft;
                const firstItem = scrollContainer.querySelector('.comment-card');
                const itemWidth = firstItem ? firstItem.offsetWidth + 16 : 300 + 12; // width + margin, fallback to default
                const activeIndex = Math.round(scrollPosition / itemWidth);
                
                bullets.forEach((bullet, index) => {
                    bullet.classList.toggle('active', index === activeIndex);
                });
            });
        }
    }

    setupNotifyStudentLevelModal() {
        const modal = document.getElementById('notifyStudentLevelModal');
        const form = document.getElementById('notify-student-level-form');
        const alertStatusInput = document.getElementById('should_postpone_exam');
        const skillNoteButtons = document.querySelectorAll('.skill-note-button');
        const submitButton = modal.querySelector('.modal-footer button[type="button"]');
        const errorMessageDiv = document.getElementById('notify-student-level-error-message');

        skillNoteButtons.forEach(button => {
            button.addEventListener('click', () => {
                skillNoteButtons.forEach(btn => btn.classList.remove('selected'));
                button.classList.add('selected');
                alertStatusInput.value = button.getAttribute('data-status');
                errorMessageDiv.classList.add('d-none');
            });
        });

        form.querySelectorAll('input, textarea').forEach(input => {
            input.addEventListener('input', () => {
                errorMessageDiv.classList.add('d-none');
            });
        });

        form.addEventListener('submit', (event) => {
            event.preventDefault();
            if (this.isFormValid(form)) {
                this.submitForm(form);
            }
            // } else {
            //     errorMessageDiv.textContent = 'Veuillez remplir tous les champs requis.';
            //     errorMessageDiv.classList.remove('d-none');
            // }
        });

        submitButton.addEventListener('click', () => {
            form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
    }

    isFormValid(form) {
        // Initialize jQuery validate
        $(form).validate({
            ignore: [],
            rules: {
                'alert[should_postpone_exam]': {
                    required: true,
                    minlength: 1,
                },
                'alert[recommended_additional_hours]': {
                    required: true
                },
                'alert[comment]': {
                    required: true,
                    minlength: 1,
                }
            },
            messages: {
                'alert[should_postpone_exam]': 'Veuillez sélectionner une option',
                'alert[recommended_additional_hours]': "Veuillez saisir le nombre d'heures, ou 0 si aucune heure n'est recommandée",
                'alert[comment]': {
                    required: 'Veuillez saisir un commentaire',
                    minlength: 'Veuillez saisir un commentaire'
                }
            },
            errorClass: 'is-invalid',
            errorElement: 'div',
            errorPlacement: function(error, element) {
                console.log(error);
                console.log(element);
                console.log("----");
                error.addClass('invalid-feedback');
                error.insertAfter(element);
            }
        });

        // Add custom validation for radio buttons
        $.validator.addMethod('levelWarningRequired', function() {
            return $('#level_warning_yes').is(':checked') || $('#level_warning_no').is(':checked');
        }, 'Please select an option');
        
        // Add the rule to a hidden field that represents the radio group
        $('#level_warning_yes').rules('add', {
            levelWarningRequired: true
        });

        // Return the result of the validation
        return $(form).valid();
    }

    submitForm(form) {
        const formData = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.open('POST', form.action, true);
        xhr.setRequestHeader('Accept', 'text/javascript');
        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    eval(xhr.responseText);
                } else {
                    alert('Erreur lors de l\'envoi de l\'alerte.');
                }
            }
        };
        xhr.send(formData);
    }
}